import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { Routes } from 'react-router-dom'
import mapRouterHelper from '../../utils/MapRouterHelper'
import { PHAN_BO_TRANG_THIET_BI_SHORT_PREFIX_URL } from './constants/config.phan-bo-trang-thiet-bi'
import WorkingEquipmentRouters from './modules/working-equipment/WorkingEquipment.Routers'
import WorkingEquipmentAllocationRouters from './modules/working-equipment-allocation/WorkingEquipmentAllocation.Routers'
import AdminCapPhatTrangThietBiRouters from './modules/admin-cap-phat-trang-thiet-bi/AdminCapPhatTrangThietBi.Routers'

const PhanBoTrangThietBiRouters: AppRouterItem[] = [
  {
    path: `${PHAN_BO_TRANG_THIET_BI_SHORT_PREFIX_URL}/*`,
    element: (
      <Routes>
        {mapRouterHelper(WorkingEquipmentRouters)}
        {mapRouterHelper(WorkingEquipmentAllocationRouters)}
        {mapRouterHelper(AdminCapPhatTrangThietBiRouters)}
      </Routes>
    ),
  },
]

export default PhanBoTrangThietBiRouters
